import { getPayments } from 'Api/AccountApi';
import { getFrequencyLabel } from 'Utils/Plans';
import { CLEAR_PAYMENT_HISTORY, GET_PAYMENT_ERROR, GET_PAYMENT_REQUEST, GET_PAYMENT_SUCCESS } from '../Types';

// action creators
export const getPaymentSuccess = ({ orders, nextBillInfo }) => ({
  type: GET_PAYMENT_SUCCESS,
  orders,
  nextBillInfo,
});
export const getPaymentRequest = () => ({ type: GET_PAYMENT_REQUEST });
export const getPaymentError = (payload) => ({ type: GET_PAYMENT_ERROR, payload });
export const clearPaymentHistory = () => ({ type: CLEAR_PAYMENT_HISTORY });

// helpers
const getOrdersAndNextBillInfo = ({ order = [], nextBillInformation = {} }, appId) => {
  let nextBillInfo = null;
  const orders = order.filter(
    (od) =>
      od.orderProductInfo.some((opi) => opi.appId === appId) && ['INVOICE', 'ORDER'].includes(od.type.toUpperCase())
  );

  // invoice or an order(no free trials)
  const nextBillOrder = orders.find((order) => order.nextBillInformation);
  if (nextBillOrder) {
    const { nextBillInformation, orderProductInfo = [] } = nextBillOrder;
    const { nextBillingDateTime, nextBillingAmount } = nextBillInformation;
    const activeOrder = orderProductInfo.find((o) => o.appId === appId);

    const { displayName, chargedPrice, retailPrice, duration, period, endDate } = activeOrder;
    const planFrequency = getFrequencyLabel({ duration, period });

    nextBillInfo = {
      nextBillingDateTime: nextBillingDateTime > 0 ? nextBillingDateTime : endDate,
      nextBillingAmount,
      planName: displayName,
      planPrice: chargedPrice || retailPrice,
      planFrequency,
    };
  }

  // for free trials.
  const subscriptionsInfo = nextBillInformation?.subscriptionsInfo?.find((sub) => sub.appId === appId);
  if (subscriptionsInfo) {
    const { nextBillingDateTime, nextBillingAmount, originalPrice, displayName, duration, period } = subscriptionsInfo;
    const planFrequency = getFrequencyLabel({ duration, period });
    nextBillInfo = {
      nextBillingDateTime,
      nextBillingAmount,
      planName: displayName,
      planPrice: originalPrice,
      planFrequency,
    };
  }

  return { orders, nextBillInfo };
};

// action thunks
export const fetchPayments = (appId) => {
  return async (dispatch) => {
    dispatch(getPaymentRequest());
    try {
      const data = await getPayments();
      const ordersAndNextBillInfo = await getOrdersAndNextBillInfo(data, appId);
      dispatch(getPaymentSuccess(ordersAndNextBillInfo));
    } catch (error) {
      dispatch(getPaymentError(error.message));
    }
  };
};
